// removed by extract-text-webpack-plugin
module.exports = {"StepFive":"StepFive-module__StepFive__2X8oQ","InputWrapper":"StepFive-module__InputWrapper__2FwGs","Footer":"StepFive-module__Footer__2EiLD","TopTextWrapper":"StepFive-module__TopTextWrapper__3CDLa","TextWrapper":"StepFive-module__TextWrapper__2wEDS","SpinnerWrapper":"StepFive-module__SpinnerWrapper__2OhZw","CrossRegWrapper":"StepFive-module__CrossRegWrapper__hawUo","Html":"StepFive-module__Html__39MGa"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Auth/EmailRegisterInner/Steps/StepFive/StepFive.module.css
// module id = 1750
// module chunks = 29